import { useRef, useState } from "react";
import { IVoiceItem } from "@/types/voice";
import Dialog from "@/component/Dialog";
import SpeakerAvatar from "../SpearkerAvatar";
import { IOptions, Select } from "@/component/Select";
import { RuningInLink } from "@/constants";
import { getRatio } from "@/utils/window";
import VoiceEditModal, { VoiceEditModalRef } from "../VoiceEditModal";
import VoiceCardLeftIcon from "@/assets/common/ic_voice_card_left.svg?react";
import VoiceCardRightIcon from "@/assets/common/ic_voice_card_right.svg?react";
import VoiceCardMoreIcon from "@/assets/common/ic_voice_card_more.svg";
import SimpleAudioPlayer from "../SimpleAudioPlayer";
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { deleteVoice } from "@/services/voice";
import fridayReporter from "@/utils/friday";
import { message } from "antd";

interface VoiceCardProps {
  voiceItem: IVoiceItem;
  handleCallback: (newModel: IVoiceItem) => void;
  deleteCallback: () => void;
  onAudioChange: (currentAudio: AudioPlayerIns) => void;
}

const VoiceCard: React.FC<VoiceCardProps> = ({
  voiceItem,
  handleCallback,
  deleteCallback,
  onAudioChange,
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [positioned, setPositioned] = useState<(number | undefined)[]>([
    0, 0, 0, 0,
  ]);
  const [roleName, setRoleName] = useState(voiceItem.roleName);
  const voiceEditModalRef = useRef<VoiceEditModalRef>(null);

  const cancelDelete = () => {
    setShowDialog(false);
  };

  const confirmDelete = async () => {
    setShowDialog(false);
    try {
      await deleteVoice(voiceItem.id);
      message.success("删除声纹成功");
      // 刷新列表
      deleteCallback();
    } catch (error) {
      message.success("删除声纹失败");
      console.error("deleteRecord error", error);
    }
  };

  const showMoreHandle = async () => {
    let devicePixelRatio = 1;
    if (RuningInLink) {
      devicePixelRatio = (await getRatio()) ?? 1;
    }
    setPositioned([
      undefined,
      undefined,
      36 * devicePixelRatio,
      -13 * 4 * devicePixelRatio,
    ]);
    setShowSelect(true);
  };

  const choseHandle = async (value: IOptions) => {
    switch (value.id) {
      case "rename": {
        fridayReporter.pushData({
          eventCode: 'HomePage_VoiceFiles_VoiceManage_Edit'
        })
        voiceEditModalRef.current?.open();
        break;
      }
      case "delete": {
        fridayReporter.pushData({
          eventCode: 'HomePage_VoiceFiles_VoiceManage_Delete'
        })
        setShowDialog(true);
        break;
      }
    }
    setShowMore(!showMore);
    setShowSelect(!showSelect);
  };

  const options = [
    { id: "rename", label: "编辑" },
    { id: "delete", label: "删除" },
  ];

  const myHandleCallback = (newModel: IVoiceItem) => {
    setRoleName(newModel.roleName);
    handleCallback(newModel);
  };

  const onPlayingChange = (isPlaying: boolean) => {
    if (isPlaying) {
      fridayReporter.pushData({
        eventCode: 'HomePage_VoiceFiles_VoiceManage_Play'
      })
    }
  }

  return (
    <div
      className={`w-76.5 h-33 bg-#fff rounded-2 pt-6 hover:shadow-[0px_4px_16px_0px_#191D2612] select-none`}
      onMouseEnter={() => {
        setShowMore(true);
      }}
      onMouseLeave={() => {
        setShowSelect(false);
        setShowMore(false);
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="flex items-center">
        <VoiceCardLeftIcon className="w-5 h-3.5 mr-1" />
        <div className="w-8 h-8 relative">
          <SimpleAudioPlayer
            className={`w-full h-full absolute ${showMore ? "" : "z--1"}`}
            avatarIndex={voiceItem.avatarIndex}
            fileKey={voiceItem.fileKey}
            onAudioChange={onAudioChange}
            onPlayingChange={onPlayingChange}
          />
          <SpeakerAvatar
            className={`w-full h-full absolute ${showMore ? "z--1" : ""}`}
            avatarIndex={voiceItem.avatarIndex}
            speakerName={roleName}
          />
        </div>
        <VoiceCardRightIcon className="w-61.5 h-8 ml-1" />
      </div>
      <div className="flex items-center justify-between mt-6 h-8  pl-6 pr-6">
        <div className="font-500 color-mx-secondary text-4">
          {roleName}
        </div>
        {showMore && (
          <div className="">
            <div
              className={`relative rd-2.5 w-8 h-8 cursor-pointer ${showSelect ? "bg-#F4F6F9" : ""
                }`}
            >
              <img
                className="w-8 h-8"
                src={VoiceCardMoreIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  showMoreHandle();
                }}
              ></img>
              {showSelect && (
                <Select
                  positioned={positioned}
                  options={options}
                  onChose={choseHandle}
                  onOutsideCb={() => {
                    setShowSelect(!showSelect);
                  }}
                ></Select>
              )}
            </div>
          </div>
        )}
      </div>
      <Dialog
        isOpen={showDialog}
        title="确定删除"
        content={`删除后，将不再识别${voiceItem.roleName}的声音`}
        onCancel={cancelDelete}
        onConfirm={confirmDelete}
      ></Dialog>
      <VoiceEditModal
        ref={voiceEditModalRef}
        voiceItem={voiceItem}
        handleCallback={myHandleCallback}
      />
    </div>
  );
};

export default VoiceCard;
